<template>
  <div class="form-group" :class="getClasses()">
    <label v-if="label" :for="name" class="text-info">{{ label }}</label>
    <input type="number"
           @input="updateValue($event.target.value)"
           @keyup="checkMax()"
           :value="value"
           :name="name"
           :step="step"
           :min="min"
           :max="max"
           :required="required"
           :disabled="disabled"
           :placeholder="placeholder"
           class="form-control"
    >
    <span v-if="error"
          class="help-block"
          v-html="error"
    ></span>
  </div>
</template>

<script>
  export default{
    name: 'InputNumber',
    props: ['name', 'value', 'step', 'min', 'max', 'required', 'label', 'placeholder', 'error', 'disabled', 'classes'],
    methods: {
      updateValue (value) {
        this.$emit('input', value)
      },
      checkMax () {
        if (this.value > this.max) {
          this.$emit('input', this.max)
        }
      },
      getClasses () {
        let str = this.error ? 'has-error ' : ''
        if (this.classes) str += this.classes
        return str
      }
    }
  }
</script>


// WEBPACK FOOTER //
// InputNumber.vue?de00b546